import styled, { keyframes } from "styled-components";

//
// ✅ Skeleton animation
//
const shimmer = keyframes`
  0% { background-position: 0% 0%; }
  100% { background-position: -200% 0%; }
`;

export const Page = styled.div`
  width: 100%;
  padding: 12px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
`;

//
// ✅ ✅ ✅ 새 스켈레톤 – 카드와 동일한 레이아웃
//
export const SkeletonGrid = styled.div`
  display: grid;
  gap: 12px;

  & > div {
    height: auto;
  }

  &::before,
  &::after,
  & div:nth-child(3) {
    content: "";
    display: block;
    height: 180px;
    border-radius: 10px;
    background: linear-gradient(90deg, #e5e7eb, #f3f4f6, #e5e7eb);
    background-size: 200% 100%;
    animation: ${shimmer} 1s ease-in-out infinite;
    border: 1px solid #e5e7eb;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  }
`;

//
// ✅ 카드 컨테이너
//
export const CardContainer = styled.section<{
  $open?: boolean;
  $clickable?: boolean;
}>`
  width: 100%;
  position: relative;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  padding: 14px;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.07);
  display: grid;
  gap: 12px;
  ${({ $clickable }) => $clickable && "cursor: pointer;"}

  opacity: 1; /* ✅ mount 직후는 무조건 0 */
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
`;

export const HName = styled.h3`
  margin: 0;
  font-size: 17px;
  font-weight: 900;
  color: #0f172a;
`;

export const ToggleHint = styled.div<{ $open: boolean; $visible: boolean }>`
  position: absolute;
  right: 12px;
  top: 8px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  background: ${({ $open }) => ($open ? "#eef2ff" : "#f8fafc")};
  border: 1px solid ${({ $open }) => ($open ? "#c7d2fe" : "#e2e8f0")};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.2s ease;
`;

export const Arrow = styled.span<{ $open: boolean }>`
  margin-left: 6px;
  display: inline-block;
  border-left: 7px solid currentColor;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  transform: rotate(${({ $open }) => ($open ? "90deg" : "0deg")});
  transition: transform 0.15s ease;
`;

export const AvailWrap = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

export const AvailChip = styled.span<{ $color?: string }>`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  background: #f8fafc;
  border: 1px solid #e5e7eb;

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 99px;
    background: ${({ $color }) => $color};
  }
`;

export const DesktopGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;

  @container card (max-width: 820px) {
    display: none;
  }
`;

export const MobileTopRow = styled.div`
  display: none;

  @container card (max-width: 820px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
`;

export const MobileGpuRow = styled.div`
  display: none;

  @container card (max-width: 820px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
`;
